import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useIsMobile } from "../../hooks/useIsMobile";
var withHoverBehavior = function withHoverBehavior(WrappedComponent) {
  return function (props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inViewport = _useState2[0],
      setInViewport = _useState2[1];
    var isMobileScreen = useIsMobile();
    var handleMouseEnter = function handleMouseEnter() {
      if (!isMobileScreen) {
        setInViewport(true);
      }
    };
    var handleMouseLeave = function handleMouseLeave() {
      if (!isMobileScreen) {
        setInViewport(false);
      }
    };
    var handleClick = function handleClick() {
      if (props.setIsSelected) {
        props.setIsSelected();
        setInViewport(false);
      }
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      handleClick: handleClick,
      handleMouseEnter: handleMouseEnter,
      handleMouseLeave: handleMouseLeave,
      inViewport: inViewport
    }));
  };
};
export default withHoverBehavior;